import { useCallback, useEffect, useState } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";
import localStorageConstants from "src/app/constants/localStorage.constants";
import drawerOptions from "src/app/constants/mainDrawer.constants";
import { useIsMobile } from "src/app/hooks/useIsMobile";
import DrawerModel, {
  DrawerOption,
} from "src/app/models/components/drawer.model";

const DrawerComponentViewModel = (drawerProps: DrawerModel) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const isMobile: boolean = useIsMobile();
  const navigate: NavigateFunction = useNavigate();
  const [userRole, setUserRole] = useState<string | undefined>(undefined);
  const [roleSpecificDrawerOptions, setRoleSpecificDrawerOptions] = useState<
    DrawerOption[]
  >([]);
  const [separateSites, setSeparateSites] = useState<boolean | undefined>(
    undefined,
  );
  const [selectedId, setSelectedId] = useState<string>("");

  useEffect(() => {
    const storedUserRole: string | null = localStorage.getItem(
      localStorageConstants.ROLE,
    );
    if (!storedUserRole) return;
    setUserRole(storedUserRole);
    const storedSeparateSites: string | null = localStorage.getItem(
      localStorageConstants.SEPARATE_PAGES_PREFERENCE,
    );
    setSeparateSites(storedSeparateSites === "true");
  }, []);

  useEffect(() => {
    if (!drawerProps.selectedId) return;
    setSelectedId(drawerProps.selectedId);
    if (drawerProps.separateSites !== undefined)
      setSeparateSites(drawerProps.separateSites);
  }, [drawerProps]);

  const getPageVariation = useCallback(() => {
    const option = drawerOptions.find((o) => o.displayName === selectedId);
    if (option?.variation === "warpa") return "warpa";
    if (option?.variation === "pod") return "pod";
    return "";
  }, [selectedId]);

  useEffect(() => {
    if (!userRole || !selectedId || separateSites === undefined) return;
    let filteredResult: DrawerOption[] = drawerOptions.filter(
      (drawerOption: DrawerOption) =>
        drawerOption.acceptedRoles.includes(userRole),
    );
    if (separateSites) {
      filteredResult = filteredResult.filter(
        (option: DrawerOption) => option.variation === getPageVariation(),
      );
    }
    setRoleSpecificDrawerOptions(filteredResult);
  }, [userRole, selectedId, separateSites, getPageVariation]);

  const toggleDrawer = (newOpen: boolean) => () => {
    setIsDrawerOpen(newOpen);
  };
  const navigateToScreen = (screenPath: string) => {
    navigate(screenPath);
  };

  const logout = () => {
    localStorage.removeItem(localStorageConstants.TOKEN);
    localStorage.removeItem(localStorageConstants.ROLE);
    localStorage.removeItem(localStorageConstants.SEPARATE_PAGES_PREFERENCE);
    navigate("/");
  };

  const switchBetweenSites = () => {
    if (getPageVariation() === "warpa") {
      navigate("/podDashboard");
    } else {
      navigate("/dashboard");
    }
  };

  return {
    isDrawerOpen,
    toggleDrawer,
    isMobile,
    navigateToScreen,
    roleSpecificDrawerOptions,
    logout,
    separateSites,
    getPageVariation,
    switchBetweenSites,
  };
};

export default DrawerComponentViewModel;
